import { z } from 'zod/v3';
import { IntegrationTypeSchema } from '../generated/enums';

// Integration DTOs
export const IntegrationDTOSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: IntegrationTypeSchema,
  workspaceId: z.string(),
  workspace: z.string(),
  config: z.record(z.unknown()).optional(),
  metadata: z.record(z.unknown()).optional(),
  status: z.string(),
  sources: z.array(z.string()),
  createdAt: z.date(),
  updatedAt: z.date()
}).strict();

export const IntegrationListDTOSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: IntegrationTypeSchema,
  status: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
}).strict();

export const CreateIntegrationDTOSchema = z.object({
  name: z.string(),
  type: IntegrationTypeSchema,
  workspaceId: z.string(),
  workspace: z.string(),
  config: z.record(z.unknown()).optional(),
  metadata: z.record(z.unknown()).optional(),
  status: z.string(),
  sources: z.array(z.string())
}).strict();

export const UpdateIntegrationDTOSchema = z.object({
  id: z.string(),
  name: z.string().optional(),
  type: IntegrationTypeSchema.optional(),
  workspaceId: z.string().optional(),
  workspace: z.string().optional(),
  config: z.record(z.unknown()).optional(),
  metadata: z.record(z.unknown()).optional(),
  status: z.string().optional(),
  sources: z.array(z.string()).optional()
}).strict();

export type IntegrationDTO = z.infer<typeof IntegrationDTOSchema>;
export type IntegrationListDTO = z.infer<typeof IntegrationListDTOSchema>;
export type CreateIntegrationDTO = z.infer<typeof CreateIntegrationDTOSchema>;
export type UpdateIntegrationDTO = z.infer<typeof UpdateIntegrationDTOSchema>;
